// @flow
import * as React from 'react'
import logError from 'mz-utils/logError'
import getCreditCards from 'mz-sdk/services/creditcard/getCreditCards'
import Button from 'mz-ui-kit/core/Button'
import LoadingSpinner from 'mz-ui-kit/core/LoadingSpinner'
import Alert from 'mz-ui-kit/core/Alert'
import { FormattedMessage } from 'mz-intl'
import type { Input, Meta } from 'mz-ui-kit/core/BaseField'
import type { PaymentOption } from 'mz-sdk/services/creditcard/getCreditCards'
import { wrapWithField } from '../../Field'
import messages from '../messages.intl'
import {
  Container,
  LoadingContainer,
  CreditCardWrapper,
  TryAgainButtonContainer,
} from './elements'

// Types
import type { MethodProps } from '..'
import CreditCardItem from '../CreditCardItem'

export type Props = MethodProps & {
  input: Input,
  meta: Meta,
}
type State = {
  userCards: Array<PaymentOption>,
  initError: boolean,
  loading: boolean,
}

export class SavedCardsMethod extends React.Component<Props, State> {
  iteration = 0

  state = {
    userCards: [],
    initError: false,
    loading: false,
  }

  componentDidMount() {
    this.initPaymentOptions()
  }

  initPaymentOptions = async () => {
    const { shouldSecurePayment, changeMeta } = this.props

    const activeIteration = ++this.iteration
    const safeSetState = (state) =>
      activeIteration === this.iteration && this.setState(state)

    try {
      safeSetState({ loading: true, initError: false })

      const userCards = await getCreditCards()

      if (userCards.some((card) => shouldSecurePayment && !card.is_secure)) {
        changeMeta &&
          changeMeta({ warning: messages.DISABLED_CARDS_3DS_NOTICE })
      }

      if (activeIteration === this.iteration) {
        safeSetState({ userCards })
      }
    } catch (e) {
      logError(e)
      safeSetState({ initError: true })
    } finally {
      safeSetState({ loading: false })
    }
  }

  render() {
    const { allowedPaymentOptionIds, shouldSecurePayment } = this.props
    const { userCards, loading, initError } = this.state
    const filteredOptions = allowedPaymentOptionIds
      ? userCards.filter((x) => allowedPaymentOptionIds.indexOf(x.id) >= 0)
      : userCards
    const havePaymentOptions = !!(
      !loading &&
      filteredOptions &&
      filteredOptions.length
    )

    if (loading)
      return (
        <LoadingContainer>
          <LoadingSpinner size="normal" />
        </LoadingContainer>
      )

    if (initError)
      return (
        <Container>
          <Alert color="red">
            <FormattedMessage message={messages.OPTIONS_INIT_ERROR} />
            <TryAgainButtonContainer>
              <Button color="red" onClick={this.initPaymentOptions}>
                <FormattedMessage message={messages.RETRY_STRIPE_INIT} />
              </Button>
            </TryAgainButtonContainer>
          </Alert>
        </Container>
      )

    return (
      !!havePaymentOptions && (
        <Container>
          {filteredOptions.map((card, i) => (
            <CreditCardWrapper key={i}>
              <CreditCardItem
                input={this.props.input}
                meta={this.props.meta}
                option={card}
                disabled={shouldSecurePayment && !card.is_secure}
                methodProps={this.props}
              />
            </CreditCardWrapper>
          ))}
        </Container>
      )
    )
  }
}

export default wrapWithField(SavedCardsMethod)
